(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-media-gallery-content"] && !Shopify.designMode) return;
  try {
    function initThumbnailScroll() {
  document.querySelectorAll('.slideshow-controls__thumbnails').forEach(slider => {
    if (slider._scrollInit) return;
    slider._scrollInit = true;

    let isDown = false;
    let startX = 0;
    let scrollLeft = 0;
    let moved = false;

    slider.addEventListener('mousedown', (e) => {
      isDown = true;
      moved = false;
      startX = e.clientX;
      scrollLeft = slider.scrollLeft;
      slider.style.cursor = 'grabbing';
      e.preventDefault();
    });

    window.addEventListener('mouseup', () => {
      isDown = false;
      slider.style.cursor = 'grab';
    });

    window.addEventListener('mousemove', (e) => {
      if (!isDown) return;

      const diff = e.clientX - startX;

      if (Math.abs(diff) > 3) moved = true;

      slider.scrollLeft = scrollLeft - diff;
    });

    slider.addEventListener('click', (e) => {
      if (!moved) return;

      e.preventDefault();
      e.stopImmediatePropagation();

      moved = false;
    }, true);

    let touchStartX = 0;
    let touchScrollLeft = 0;

    slider.addEventListener('touchstart', (e) => {
      touchStartX = e.touches[0].clientX;
      touchScrollLeft = slider.scrollLeft;
    }, { passive: true });

    slider.addEventListener('touchmove', (e) => {
      const diff = touchStartX - e.touches[0].clientX;
      slider.scrollLeft = touchScrollLeft + diff;
    }, { passive: true });

    slider.style.cursor = 'grab';
    slider.style.userSelect = 'none';
  });
}

initThumbnailScroll();

const observer = new MutationObserver(() => {
  initThumbnailScroll();
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-media"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.product-media').forEach((card) => {
    const video = card.querySelector('[data-hover-video]');
    if (!video) return;

    card.addEventListener('mouseenter', () => {
      video.play().then(() => video.classList.add('is-playing')).catch(() => {});
    });

    card.addEventListener('mouseleave', () => {
      video.pause();
      video.currentTime = 0;
      video.classList.remove('is-playing');
    });
  });
});

document.addEventListener('mouseover', function (e) {
  const card = e.target.closest('.recommended-product-section .product-media');
  if (!card) return;

  const video = card.querySelector('[data-hover-video]');
  if (!video || video.classList.contains('is-playing')) return;

  video.play().then(() => {
    video.classList.add('is-playing');
  }).catch(() => {});
});

document.addEventListener('mouseout', function (e) {
  const card = e.target.closest('.recommended-product-section .product-media');
  if (!card) return;

  const video = card.querySelector('[data-hover-video]');
  if (!video) return;

  video.pause();
  video.currentTime = 0;
  video.classList.remove('is-playing');
});
  } catch(e) { console.error(e); }
})();

})();
